function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tasks from '@/js/tasks';
import CustomerInsightsService from '@/apps/customer-insigths/services/customer_insights_service';
import { mapActions, mapState } from 'vuex';
export default {
  name: 'UpdateHoursMaintenanceComponent',
  data: function data() {
    return {
      items: [],
      keyTable: 0,
      updateTime: null,
      DIALOG_ADD_UPDATE_HOUR: 'DIALOG_ADD_UPDATE_HOUR',
      DIALOG_EDIT_UPDATE_HOUR: 'DIALOG_EDIT_UPDATE_HOUR',
      DIALOG_DELETE_UPDATE_HOUR: 'DIALOG_DELETE_UPDATE_HOUR',
      edit: false,
      item: null
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('customer-insights', ['getUpdateHours'])), {}, {
    onAdd: function onAdd() {
      this.$refs[this.DIALOG_ADD_UPDATE_HOUR].onOpen();
    },
    onOpenEditDialog: function onOpenEditDialog(item) {
      this.item = item;
      this.updateTime = this.item.hour_formatted;
      this.edit = true;
      this.$refs[this.DIALOG_EDIT_UPDATE_HOUR].onOpen();
    },
    onOpenDialog: function onOpenDialog(modalName, item) {
      this.item = item;
      this.$refs[modalName].onOpen();
    },
    onSubmitUpdateHour: function onSubmitUpdateHour() {
      var _this = this;
      if (!this.updateTime) {
        tasks.toast.error('Seleccione una hora de actualización para continuar.');
        return;
      }
      var updateTimeSplitted = this.updateTime.split(':');
      var hour = updateTimeSplitted[0];
      var minutes = updateTimeSplitted[1];
      var objectHour = {
        code: hour,
        hour: hour,
        minutes: minutes,
        hour_formatted: this.updateTime
      };
      var promise = null;
      var modalName = this.DIALOG_ADD_UPDATE_HOUR;
      var params = {
        update_hour: objectHour
      };
      if (this.edit) {
        promise = CustomerInsightsService.editUpdateHour(this.item.document_id, params);
        modalName = this.DIALOG_EDIT_UPDATE_HOUR;
      } else {
        promise = CustomerInsightsService.addUpdateHour(params);
      }
      promise.then(function (response) {
        _this.getUpdateHours();
        _this.keyTable += 1;
        _this.edit = false;
        _this.item = null;
        _this.updateTime = null;
        _this.$refs[modalName].onClose();
      });
    },
    onConfirmDeleteUpdateHour: function onConfirmDeleteUpdateHour(event) {
      var _this2 = this;
      if (event) {
        CustomerInsightsService.deleteUpdateHour(this.item.document_id).then(function (response) {
          _this2.getUpdateHours();
          _this2.keyTable += 1;
          _this2.item = null;
          _this2.updateTime = null;
        });
      }
      this.$refs[this.DIALOG_DELETE_UPDATE_HOUR].onClose();
    }
  }),
  computed: _objectSpread(_objectSpread({}, mapState('customer-insights', ['updateHours'])), {}, {
    headers: function headers() {
      return [{
        value: 'hour_formatted',
        text: 'Hour'
      }, {
        value: 'actions',
        text: ''
      }];
    }
  })
};